<template>
  <div class="home">
    <div class="news">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="17" :xl="17">
          <div class="info">
            <div class="title-box">
              <p>学校新闻</p>
              <s></s>
              <span @click="jumpTo('news', '3')">更多新闻＋</span>
            </div>
            <div class="info-box">
              <el-row :gutter="30">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <div class="carousel-box hidden-sm-and-down">
                    <carousel />
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <div class="info-data">
                    <div
                      @click="jumpDn(writeList[0].id)"
                      style="cursor: pointer;"
                    >
                      <h4 class="info-title">
                        {{ writeList[0].title || "未知" }}
                      </h4>
                      <strong class="info-date">{{
                        writeList[0].create_time | dateFormat
                      }}</strong>
                      <div class="info-value">
                        {{ writeList[0].content | removeHtml }}
                      </div>
                    </div>

                    <ul class="info-list">
                      <li
                        v-for="(item, index) in writeList1"
                        :key="index"
                        @click="jumpDn(item.id)"
                      >
                        <span class="fl">{{ item.title || "未知" }}</span>
                        <span class="fr">{{
                          item.create_time | dateFormat3
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
          <div class="login-box hidden-sm-and-down">
            <div class="login-type">
              <div
                class="teacher"
                :class="{ 'login-active': loginType == 1 }"
                @click="loginTeacher"
              >
                教师登录
              </div>
              <div
                class="student"
                :class="{ 'login-active': loginType == 2 }"
                @click="loginStudent"
              >
                学生登录
              </div>
            </div>
            <div class="input-username">
              <img src="./../assets/5.png" alt="用户名图标" />
              <input
                type="text"
                id="InputUsername"
                placeholder="用户名"
                v-model="formLogin.loginUsername"
              />
            </div>
            <div class="input-password">
              <img src="./../assets/2.png" alt="用户名图标" />
              <input
                type="text"
                id="InputPassword"
                placeholder="密  码"
                v-model="formLogin.loginPassword"
              />
            </div>
            <button @click="submitLogin">登录</button>
            <div class="login-other">
              <div class="fl">
                微信登陆：<img
                  @click="wechatLogin"
                  class="wechaticon"
                  src="./../assets/103.png"
                  alt="微信登陆"
                />
              </div>
              <div class="fr forget" @click="forgetPass">忘记密码？</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="school" v-if="schoolList.length > 0">
      <h3>招生学校</h3>
      <div class="school-box">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8"
            v-for="(item, index) in schoolList"
            :key="index"
          >
            <div
              class="div-img"
              v-if="item.img != null"
              @click="jumpD6(item.id, item.name)"
            >
              <img :src="item.img" :alt="item.name" v-if="item.img != ''" />
            </div>

            <div
              class="div"
              v-else
              :style="{ backgroundColor: item.color }"
              @click="jumpD6(item.id, item.name)"
            >
              <img :src="item.logo" :alt="item.name" v-if="item.logo != ''" />
              <span>{{ item.name }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="profession">
      <h3>招生专业</h3>
      <div class="div-row" style="overflow:hidden">
        <div class="div-col div-col-left">
          <div class="profession-left">
            <p>专升本专业</p>
            <ul v-if="oneList != null">
              <li
                v-for="(item, index) in oneList"
                :key="index"
                @click="jumpD(item.id)"
              >
                <span :title="item.name">{{ item.name }} </span>
              </li>
            </ul>
            <span class="no-data" v-else>暂无数据</span>
          </div>
        </div>
        <!-- <p class="pro-line"></p> -->
        <div class="div-col div-col-right">
          <div class="profession-right">
            <p>专科专业</p>
            <ul v-if="twoList != null">
              <li
                v-for="(item, index) in twoList"
                :key="index"
                @click="jumpD(item.id)"
              >
                <span :title="item.name">{{ item.name }} </span>
              </li>
            </ul>
            <span class="no-data" v-else>暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div class="poster">
      <img :src="img2" alt="广告" />
    </div>
    <div class="bulletin">
      <el-row :gutter="30">
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="main">
            <div class="head">
              <h3>通知公告</h3>
              <div class="more" @click="jumpTo('/serve/serve-list2', '5-2')">
                <i> </i>
                <span>更多</span>
              </div>
            </div>
            <p
              v-for="(item, index) in postList"
              :key="index"
              @click="jumpD2(item.id)"
            >
              {{ item.create_time | dateFormat }}
              {{ item.title || "未知" }}
            </p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="main">
            <div class="head">
              <h3>教学计划</h3>
              <div class="more" @click="jumpTo('/serve/serve-list1', '5-1')">
                <i> </i>
                <span>更多</span>
              </div>
            </div>
            <p
              v-for="(item, index) in dataList"
              :key="index"
              @click="jumpD1(item.id)"
            >
              {{ item.create_time | dateFormat }} {{ item.name }}
            </p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="main">
            <div class="head">
              <h3>资料下载</h3>
              <div class="more" @click="jumpTo('/serve/serve-list5', '5-4')">
                <i> </i>
                <span>更多</span>
              </div>
            </div>
            <p
              v-for="(item, index) in materialList"
              :key="index"
              @click="jumpD5(item.id)"
            >
              {{ item.create_time | dateFormat }} {{ item.name }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <button class="login-btns" @click="openDialog">
      <img src="./../assets/19.png" alt="登录" />
    </button>

    <div class="right-suspension">
      <div class="wechat" @mouseover="show1 = true" @mouseout="show1 = false">
        <img src="./../assets/102.png" alt="二维码" />
        <div class="wechat2" v-show="show1">
          <img src="./../assets/103.jpg" alt="二维码" />
          <p>微信二维码</p>
        </div>
      </div>
      <div class="phone" @mouseover="show2 = true" @mouseout="show2 = false">
        <img src="./../assets/101.png" alt="手机号" />
        <div class="phone2" v-show="show2">
          15305744382朱老师 13777050858张老师 18969860118陈老师
        </div>
      </div>
      <div class="qq-num" @mouseover="show3 = true" @mouseout="show3 = false">
        <img src="./../assets/100.png" alt="qq号" />
        <div class="qq-num2" v-show="show3">
          <h5>在线客服</h5>
          <p>
            <a
              target="_blank"
              href="http://wpa.qq.com/msgrd?v=3&uin=1875097792&site=qq&menu=yes"
              >朱老师<img
                border="0"
                src="./../assets/108.png"
                alt="QQ客服"
                title="QQ客服"
            /></a>
          </p>
          <p>
            <a
              target="_blank"
              href="http://wpa.qq.com/msgrd?v=3&uin=289905440&site=qq&menu=yes"
              >陈老师<img
                border="0"
                src="./../assets/108.png"
                alt="QQ客服"
                title="QQ客服"
            /></a>
          </p>
          <p>
            <a
              target="_blank"
              href="http://wpa.qq.com/msgrd?v=3&uin=14332240&site=qq&menu=yes"
              >张老师<img
                border="0"
                src="./../assets/108.png"
                alt="QQ客服"
                title="QQ客服"
            /></a>
          </p>
        </div>
      </div>
    </div>
    <el-dialog title="二维码授权" :visible.sync="dialogVisibleWechat">
      <div class="dialog-content">
        <iframe :src="url" frameborder="0" width="100%"></iframe>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisibleWechat = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="登录框"
      :visible.sync="centerDialogVisible"
      width="330px"
      center
      custom-class="dialogs"
    >
      <div class="login-box">
        <div class="login-type">
          <div
            class="teacher"
            :class="{ 'login-active': loginType == 1 }"
            @click="loginTeacher"
          >
            教师登录
          </div>
          <div
            class="student"
            :class="{ 'login-active': loginType == 2 }"
            @click="loginStudent"
          >
            学生登录
          </div>
          <div class="close">
            <img
              src="./../assets/18.png"
              alt="关闭"
              @click="centerDialogVisible = false"
            />
          </div>
        </div>
        <div class="input-username">
          <img src="./../assets/5.png" alt="用户名图标" />
          <input
            type="text"
            id="InputUsername"
            placeholder="用户名"
            v-model="formLogin.loginUsername"
          />
        </div>
        <div class="input-password">
          <img src="./../assets/2.png" alt="用户名图标" />
          <input
            type="text"
            id="InputPassword"
            placeholder="密  码"
            v-model="formLogin.loginPassword"
          />
        </div>
        <button @click="submitLogin">登录</button>
        <div class="login-other">
          <div class="fl">
            微信登陆：<img
              @click="wechatLogin"
              class="wechaticon"
              src="./../assets/103.png"
              alt="微信登陆"
            />
          </div>
          <div class="fr forget" @click="forgetPass">忘记密码？</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="重置密码框"
      :visible.sync="centerDialogVisible4"
      width="600px"
      center
      custom-class="dialogs2"
    >
      <div class="password-box">
        <h2>重置密码</h2>
        <div class="items2">
          <span>手机号码</span>
          <input type="text" placeholder="请输入手机号码" v-model="phones" />
        </div>
        <div class="items2">
          <span>验证码</span>
          <input
            type="text"
            placeholder="请输入验证码"
            class="code"
            v-model="codes"
          />
          <h4 v-show="show10" @click="sendCode">获取验证码</h4>
          <h4 v-show="!show10">{{ count }}秒</h4>
        </div>
        <div class="items2">
          <span>新密码</span>
          <input
            type="password"
            placeholder="请输入新密码"
            v-model="newPass1"
          />
        </div>
        <div class="items2">
          <span>确认新密码</span>
          <input
            type="password"
            placeholder="请输入确认新密码"
            v-model="newPass2"
          />
        </div>
        <div class="items2">
          <button @click="submitPass">确认</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import router, {
  resetRouter,
  defaultRoutes,
  newRoutes,
  newRoutes2,
} from "./../router";
import {
  getActive,
  setActive,
  removeActive,
  setType,
  setActiveName,
  setActive2,
  setToken,
  setUid,
  setPhone,
  getWinfo,
  setWinfo,
  removeWinfo,
} from "@/utils/auth";
// @ is an alias to /src
import {
  getSubjectList,
  getArticleList,
  getDataList,
  getSchoolList,
  studentLogin,
  teacherLogin,
  getSiteInfo,
  sendCode,
  alterPassword,
} from "@/api/home";
import { getWxLoginInfo, bindTeacherWx, bindStudentWx } from "@/api/common";
import { uuid } from "./../utils/uuid";
import encrypt from "./../utils/encrypt";
import Carousel from "@/components/CarouselChild";
export default {
  name: "Home",
  components: { Carousel },
  data() {
    //这里存放数据
    return {
      show10: true,
      count: "",
      timer2: null,
      phones: "",
      codes: "",
      newPass1: "",
      newPass2: "",
      show1: false,
      show2: false,
      show3: false,
      dialogVisibleWechat: false,
      centerDialogVisible: false,
      centerDialogVisible4: false,
      timer: null,
      url: "",
      uuids: "",
      page: 1,
      loginType: 1,
      img2: "",
      oneList: [],
      twoList: [],
      postList: [],
      dataList: [],
      materialList: [],
      writeList: [{}, {}, {}],
      writeList1: [{}, {}, {}],
      schoolList: [],
      form: {
        name: "",
        nax: "",
      },
      formLogin: {
        loginUsername: "",
        loginPassword: "",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    dialogVisibleWechat(newName, oldName) {
      if (newName == false) {
        clearInterval(this.timer);
      }
    },
  },
  //方法集合
  methods: {
    sendCode() {
      if (this.phones == "") {
        this.$message.info("手机号不得为空");
      } else {
        const TIME_COUNT = 60;
        if (!this.timer2) {
          sendCode({ mobile: this.phones }).then((response) => {
            this.$message.success("验证码获取成功");
          });
          this.count = TIME_COUNT;
          this.show10 = false;
          this.timer2 = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show10 = true;
              clearInterval(this.timer);
              this.timer2 = null;
            }
          }, 1000);
        }
      }
    },
    submitPass() {
      if (this.phones == "") {
        this.$message.info("手机号不得为空");
      } else if (this.codes == "") {
        this.$message.info("验证码不得为空");
      } else if (this.newPass1 == "") {
        this.$message.info("新密码不得为空");
      } else if (this.newPass2 == "") {
        this.$message.info("确认新密码不得为空");
      } else if (this.newPass1 != this.newPass2) {
        this.$message.info("新密码和确认新密码不一致,请重新填写");
      } else {
        alterPassword({
          type: this.loginType == 1 ? 2 : 1,
          method: 2,
          mobile: this.phones,
          code: this.codes,
          password: this.newPass2,
        })
          .then((response) => {
            this.$message.success("密码重置成功");
            this.centerDialogVisible4 = false;
          })
          .catch((error) => {
            this.$message.error(error.msg);
          });
      }
    },
    forgetPass() {
      this.centerDialogVisible4 = true;
      this.phones = "";
      (this.codes = ""), (this.newPass1 = ""), (this.newPass2 = "");
    },
    setTime() {
      this.timer = window.setInterval(() => {
        setTimeout(this.getList1(), 0);
      }, 3000);
    },
    getList1() {
      let params = {
        type: this.loginType == 1 ? 2 : 1,
        uuid: this.uuids,
      };
      getWxLoginInfo(params).then(async (response) => {
        this.dialogVisibleWechat = false;
        clearInterval(this.timer);
        this.timer = null;
        if (response.status == 1) {
          if (this.loginType == 1) {
            setToken(response.data.token);
            setUid(response.data.uid);
            resetRouter();
            var accessRoutes = await this.$store.dispatch("user/getRouter2");
            var routers = newRoutes2;
            if (newRoutes2[0].children.length == 1) {
              var child1 = newRoutes2[0].children.concat(accessRoutes);
            } else {
              var child1 = newRoutes2[0].children
                .slice(0, 1)
                .concat(accessRoutes);
            }

            routers[0].children = child1;
            router.addRoutes(routers);
            router.options.routes = routers;
            setPhone(this.formLogin.loginUsername);
            setType(1);
            setActiveName("个人信息");
            removeActive();
            setActive2(1);
            this.$router.push({ name: "Common" });
            this.$message.success("登录成功");
          } else {
            setToken(response.data.token);
            setUid(response.data.uid);
            resetRouter();
            var accessRoutes = await this.$store.dispatch("user/getRouter");
            var routers = newRoutes;
            if (newRoutes[0].children.length == 9) {
              var child1 = newRoutes[0].children.concat(accessRoutes);
            } else {
              var child1 = newRoutes[0].children
                .slice(0, 9)
                .concat(accessRoutes);
            }
            routers[0].children = child1;
            router.addRoutes(routers);
            router.options.routes = routers;
            setPhone(this.formLogin.loginUsername);
            setType(2);
            setActiveName("个人信息");
            removeActive();
            setActive2(1);
            this.$router.push({ path: "/personal-information" });
            this.$message.success("登录成功");
          }
        } else if (response.status == 10) {
          this.$router.push({
            path: "/bind",
            query: { type: this.loginType == 1 ? 2 : 1 },
          });
        } else {
          this.dialogVisibleWechat = false;
          // window.location.reload();
        }
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    bindWX() {
      let that = this;
      let wxuserinfo = this.$route.query.userinfo;
      if (wxuserinfo != "" && wxuserinfo) {
        setWinfo(wxuserinfo);
        let userinfo = JSON.parse(decodeURI(wxuserinfo));
        if (userinfo.status === 0) {
          this.$message(userinfo.msg);
        } else if (userinfo.status === 10) {
          console.log("绑定微信成功,请绑定账号信息！");
          // this.$message("绑定微信成功,请绑定账号信息！");
        } else if (userinfo.status === 1) {
          removeWinfo();
          this.loginType = userinfo.type == 1 ? 2 : 1;
          this.submitLogin2(userinfo);
        }
      }
    },
    wechatLogin() {
      if (this._isMobile()) {
        if (this.loginType == 1) {
          window.location.href =
            "https://api.nbjss.com/api/port/wxTeacherLogin";
        } else {
          window.location.href =
            "https://api.nbjss.com/api/port/wxStudentLogin";
        }
      } else {
        uuid().then((res) => {
          var uuids = res;
          var params = {
            uuid: uuids,
          };
          var data1 = encodeURIComponent(
            encrypt.Encrypt(JSON.stringify(params), "")
          );
          this.url = "";
          this.url = "https://api.nbjss.com/api/port/wxAuthCode?data=" + data1;
          this.uuids = uuids;
          this.dialogVisibleWechat = true;
          this.setTime();
        });
      }
    },
    async submitLogin2(response) {
      if (this.loginType == 1) {
        setToken(response.data.token);
        setUid(response.data.uid);
        resetRouter();
        var accessRoutes = await this.$store.dispatch("user/getRouter2");
        var routers = newRoutes2;
        if (newRoutes2[0].children.length == 1) {
          var child1 = newRoutes2[0].children.concat(accessRoutes);
        } else {
          var child1 = newRoutes2[0].children.slice(0, 1).concat(accessRoutes);
        }

        routers[0].children = child1;
        router.addRoutes(routers);
        router.options.routes = routers;
        setPhone(this.formLogin.loginUsername);
        setType(1);
        setActiveName("个人信息");
        removeActive();
        setActive2(1);
        this.$router.push({ name: "Common" });
        this.$message.success("登录成功");
      } else {
        setToken(response.data.token);
        setUid(response.data.uid);
        resetRouter();
        var accessRoutes = await this.$store.dispatch("user/getRouter");
        var routers = newRoutes;
        if (newRoutes[0].children.length == 1) {
          var child1 = newRoutes[0].children.concat(accessRoutes);
        } else {
          var child1 = newRoutes[0].children.slice(0, 9).concat(accessRoutes);
        }

        routers[0].children = child1;
        router.addRoutes(routers);
        router.options.routes = routers;
        setPhone(this.formLogin.loginUsername);
        setType(2);
        setActiveName("个人信息");
        removeActive();
        setActive2(1);
        this.$router.push({ name: "Common" });
        this.$message.success("登录成功");
      }
    },
    submitLogin() {
      if (this.loginType == 1) {
        if (this.formLogin.loginUsername == "") {
          this.$message("用户名不得为空");
          return false;
        } else if (this.formLogin.loginPassword == "") {
          this.$message("密码不得为空");
          return false;
        } else {
          // if (getWinfo() != "" && getWinfo() != null) {
          //   let params = {
          //     username: this.formLogin.loginUsername,
          //     password: this.formLogin.loginPassword,
          //     wxinfo: getWinfo(),
          //   };
          //   bindTeacherWx(params)
          //     .then(async (response) => {
          //       setToken(response.data.token);
          //       setUid(response.data.uid);
          //       resetRouter();
          //       var accessRoutes = await this.$store.dispatch(
          //         "user/getRouter2"
          //       );
          //       var routers = newRoutes2;
          //       if (newRoutes2[0].children.length == 1) {
          //         var child1 = newRoutes2[0].children.concat(accessRoutes);
          //       } else {
          //         var child1 = newRoutes2[0].children
          //           .slice(0, 1)
          //           .concat(accessRoutes);
          //       }

          //       routers[0].children = child1;
          //       router.addRoutes(routers);
          //       router.options.routes = routers;
          //       setPhone(this.formLogin.loginUsername);
          //       setType(1);
          //       setActiveName("个人信息");
          //       removeActive();
          //       setActive2(1);
          //       this.$router.push({ name: "Common" });
          //       this.$message.success("登录成功");
          //     })
          //     .catch((error) => {
          //       this.$message.error(error.msg);
          //     });
          //   return false;
          // } else {
            let params = {
              username: this.formLogin.loginUsername,
              password: this.formLogin.loginPassword,
            };
            teacherLogin(params)
              .then(async (response) => {
                setToken(response.data.token);
                setUid(response.data.uid);
                resetRouter();
                var accessRoutes = await this.$store.dispatch(
                  "user/getRouter2"
                );
                var routers = newRoutes2;
                if (newRoutes2[0].children.length == 1) {
                  var child1 = newRoutes2[0].children.concat(accessRoutes);
                } else {
                  var child1 = newRoutes2[0].children
                    .slice(0, 1)
                    .concat(accessRoutes);
                }

                routers[0].children = child1;
                router.addRoutes(routers);
                router.options.routes = routers;
                setPhone(this.formLogin.loginUsername);
                setType(1);
                setActiveName("个人信息");
                removeActive();
                setActive2(1);
                this.$router.push({ name: "Common" });
                this.$message.success("登录成功");
              })
              .catch((error) => {
                this.$message.error(error.msg);
              });
            // return false;
          // }
        }
      } else {
        if (this.formLogin.loginUsername == "") {
          this.$message("用户名不得为空");
          return false;
        } else if (this.formLogin.loginPassword == "") {
          this.$message("密码不得为空");
          return false;
        } else {
          // if (getWinfo() != "" && getWinfo() != null) {
          //   let params = {
          //     username: this.formLogin.loginUsername,
          //     password: this.formLogin.loginPassword,
          //     wxinfo: getWinfo(),
          //   };
          //   bindStudentWx(params)
          //     .then(async (response) => {
          //       setToken(response.data.token);
          //       setUid(response.data.uid);
          //       resetRouter();
          //       var accessRoutes = await this.$store.dispatch("user/getRouter");
          //       var routers = newRoutes;
          //       if (newRoutes[0].children.length == 1) {
          //         var child1 = newRoutes[0].children.concat(accessRoutes);
          //       } else {
          //         var child1 = newRoutes[0].children
          //           .slice(0, 9)
          //           .concat(accessRoutes);
          //       }

          //       routers[0].children = child1;
          //       router.addRoutes(routers);
          //       router.options.routes = routers;
          //       setPhone(this.formLogin.loginUsername);
          //       setType(2);
          //       setActiveName("个人信息");
          //       removeActive();
          //       setActive2(1);
          //       this.$router.push({ name: "Common" });
          //       this.$message.success("登录成功");
          //     })
          //     .catch((error) => {
          //       this.$message.error(error.msg);
          //     });
          //   return false;
          // } else {
            let params = {
              username: this.formLogin.loginUsername,
              password: this.formLogin.loginPassword,
            };
            studentLogin(params)
              .then(async (response) => {
                setToken(response.data.token);
                setUid(response.data.uid);
                resetRouter();
                var accessRoutes = await this.$store.dispatch("user/getRouter");
                var routers = newRoutes;
                if (newRoutes[0].children.length == 9) {
                  var child1 = newRoutes[0].children.concat(accessRoutes);
                } else {
                  var child1 = newRoutes[0].children
                    .slice(0, 9)
                    .concat(accessRoutes);
                }
                routers[0].children = child1;
                router.addRoutes(routers);
                router.options.routes = routers;
                setPhone(this.formLogin.loginUsername);
                setType(2);
                setActiveName("个人信息");
                removeActive();
                setActive2(1);
                this.$router.push({ path: "/personal-information" });
                this.$message.success("登录成功");
              })
              .catch((error) => {
                this.$message.error(error.msg);
              });
            // return false;
          // }
        }
      }
    },
    loginTeacher() {
      if (this.loginType != 1) {
        this.loginType = 1;
        this.formLogin = {
          loginUsername: "",
          loginPassword: "",
        };
      }
    },
    loginStudent() {
      if (this.loginType != 2) {
        this.loginType = 2;
        this.formLogin = {
          loginUsername: "",
          loginPassword: "",
        };
      }
    },
    jumpD6(id, name) {
      this.$router.push({
        path: "/education/education-specialty",
        query: {
          id: id,
          name: name,
        },
      });
      setActive("4-2");
      this.$store.dispatch("user/setActive", "4-2");
    },
    jumpD5(id) {
      this.$router.push({
        path: "/serve/serve-list5d",
        query: {
          id: id,
        },
      });
      setActive("5-4");
      this.$store.dispatch("user/setActive", "5-4");
    },
    jumpD1(id) {
      this.$router.push({
        path: "/serve/serve-list1d",
        query: {
          id: id,
        },
      });
      setActive("5-1");
      this.$store.dispatch("user/setActive", "5-1");
    },
    jumpD2(id) {
      this.$router.push({
        path: "/serve/serve-list2d",
        query: {
          id: id,
        },
      });
      setActive("5-2");
      this.$store.dispatch("user/setActive", "5-2");
    },
    jumpDn(id) {
      this.$router.push({
        path: "/newsdetail",
        query: {
          id: id,
        },
      });
      setActive("3");
      this.$store.dispatch("user/setActive", "3");
    },
    jumpD(id) {
      this.$router.push({
        path: "/education/education-specialtyd1",
        query: {
          id: id,
        },
      });
      setActive("4-2");
      this.$store.dispatch("user/setActive", "4-2");
    },
    openDialog() {
      this.centerDialogVisible = true;
    },
    jumpTo(val, num) {
      this.$router.push({
        path: val,
      });
      setActive(num.toString());
      this.$store.dispatch("user/setActive", num.toString());
    },
    async fetchData() {
      let params1 = {
        page: 1,
        type: 1,
      };
      // let data1 = encrypt.Encrypt(JSON.stringify(params1), "");
      let params2 = {
        page: 1,
        type: 2,
      };
      let params3 = {
        page: 1,
        type: 3,
      };
      await getSubjectList(params1).then((response) => {
        this.oneList = response.data;
      });
      await getSubjectList(params2).then((response) => {
        this.twoList = response.data;
      });
      await getArticleList(params1).then((response) => {
        this.writeList = response.data;
        this.writeList1 = this.writeList.slice(1, 6);
      });
      await getArticleList(params3).then((response) => {
        this.postList = response.data.slice(0, 6);
      });
      await getDataList(params1).then((response) => {
        this.dataList = response.data.slice(0, 6);
      });
      await getDataList(params2).then((response) => {
        this.materialList = response.data.slice(0, 6);
      });
      await getSchoolList().then((response) => {
        this.schoolList = response.data;
      });
      await getSiteInfo({ type: 2 }).then((response) => {
        this.img2 = response.data.advertise_img;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.iswx) {
        this.centerDialogVisible=true
    }
    this.bindWX();
    this.fetchData();
  },

  beforeDestroy() {
    //页面关闭前关闭定时器 （这个才有用）
    clearInterval(this.timer);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.home {
  height: 100%;
  font-size: 14px;
  padding-top: 45px;
  padding-bottom: 50px;
  position: relative;
  .right-suspension {
    width: 50px;
    height: 150px;
    background-color: #035bb2;
    z-index: 100000000;
    position: fixed;
    bottom: 30px;
    right: 25px;
    .wechat {
      width: 50px;
      height: 50px;
      border-bottom: 1px solid #f2f2f2;
      background-color: #035bb2;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 25px;
        height: 25px;
      }
      .wechat2 {
        position: absolute;
        background-color: #035bb2;
        right: 53px;
        top: 0px;
        width: 130px;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          margin-top: 2px;
          width: 120px;
          height: 120px;
        }
        p {
          font-size: 14px;
          color: #000;
          margin: 0;
          text-align: center;
        }
      }
    }
    .phone {
      width: 50px;
      height: 50px;
      border-bottom: 1px solid #f2f2f2;
      background-color: #035bb2;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 25px;
        height: 25px;
      }
      .phone2 {
        position: absolute;
        background-color: #035bb2;
        right: 53px;
        top: -50px;
        width: 150px;
        height: 150px;
        font-size: 14px;
        line-height: 50px;
        text-align: center;
      }
    }
    .qq-num {
      width: 50px;
      height: 50px;
      border-bottom: 1px solid #f2f2f2;
      background-color: #035bb2;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 25px;
        height: 25px;
      }
      .qq-num2 {
        position: absolute;
        background-color: #035bb2;
        right: 53px;
        bottom: 0px;
        width: 200px;
        height: 173px;
        h5 {
          padding-top: 5px;
          font-size: 16px;
          color: #000;
          text-align: center;
        }
        p {
          font-size: 14px;
          padding-left: 8px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          color: #000;
          margin: 0;
          text-align: center;

          border-bottom: 1px solid #f2f2f2;
          a {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
          img {
            vertical-align: center;
            width: 70px;
            height: 20px;
            margin-left: 5px;
          }
        }
      }
    }
  }
  .login-btns {
    @media screen and (min-width: 1200px) {
      display: none;
      width: 40px;
      height: 40px;
    }
    @media screen and (max-width: 1200px) {
      width: 40px;
      height: 40px;
    }
    position: fixed;
    z-index: 100;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    padding: 0px;
    background-color: #035bb2;
    left: 10px;
    bottom: 80px;
    outline: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #ffffff;
    img {
      width: 60px;
      height: 60px;
      @media screen and (min-width: 1200px) {
        display: none;
      }
      @media screen and (max-width: 1200px) {
        width: 40px;
        height: 40px;
      }
    }
  }
  .no-data {
    font-size: 16px;
    text-align: center;
    line-height: 100px;
    display: block;
  }
  h3 {
    color: #025cb2;
    font-size: 22px;
  }
  .head {
    height: 40px;
    border-bottom: 1px solid #025ab1;
    margin-bottom: 28px;
    h3 {
      float: left;
    }
    .more {
      float: right;
      cursor: pointer;
      width: 50px;
      margin-top: 10px;
      display: flex;
      align-items: flex-end;
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #0290ff;
        background-image: url("./../assets/26.png");
        background-repeat: no-repeat;
        background-size: 80% 80%;
        background-position: center;
        margin-right: 6px;
        margin-bottom: 3px;
      }
      span {
        font-size: 16px;
        -webkit-transform-origin-x: 0;
        -webkit-transform: scale(0.75);
        color: #908e91;
      }
    }
  }
  p {
    margin-bottom: 15px;
    width: 100%;
    color: #343434;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .news {
    width: 100%;
    height: 100%;
    margin-bottom: 35px;
    .info {
      width: 100%;
      float: left;
      .title-box {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        p {
          width: 140px;
          height: 40px;
          color: #ffffff;
          background-color: #035bb2;
          font-size: 22px;
          line-height: 40px;
          text-align: center;
          margin: 0px;
        }
        s {
          width: calc(100% - 220px);
          display: block;
          line-height: 40px;
          border-top: 1px solid #cfcfcf;
          margin: 0 12px 0 3px;
        }
        span {
          color: #015bb1;
          width: 80px;
          line-height: 40px;
          display: inline-block;
          cursor: pointer;
          font-size: 13px;
        }
      }
      .info-box {
        width: 100%;
        height: 320px;
        .carousel-box {
          width: 100%;
          max-width: 470px;
          height: 320px;
        }
        .info-data {
          width: 100%;
          margin-left: 25px;
          height: 320px;
          float: right;
          .info-title {
            font-size: 22px;
            color: #045ab1;
            margin-bottom: 10px;
          }
          .info-date {
            font-size: 12px;
            color: #9a9a9a;
            display: block;
            margin-bottom: 10px;
          }
          .info-value {
            font-size: 14px;
            width: 100%;
            min-height: 65px;
            color: #999999;
            margin-bottom: 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
          .info-list li {
            list-style-type: square;
            font-size: 14px;
            width: 100%;
            height: 20px;
            color: #7d7d7d;
            margin-bottom: 10px;
            cursor: pointer;

            @media screen and (max-width: 768px) {
              list-style-type: none;
            }
            @media screen and (max-width: 992px) {
              list-style-type: none;
            }
            .fl {
              color: #333333;
              width: 80%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }
          }
        }
      }
    }

    .login-box {
      width: 330px;
      height: 365px;
      float: right;
      padding-top: 30px;
      border-top: 5px solid #025ab1;
      border-left: 1px solid #c7d8e8;
      border-right: 1px solid #c7d8e8;
      border-bottom: 1px solid #c7d8e8;
      background-color: #edf6fd;
      @media screen and (max-width: 1200px) {
        display: none;
      }
      .login-type {
        height: 35px;
        font-size: 18px;
        text-align: center;
        position: relative;
        .login-active {
          color: #015db2 !important;
          border-bottom: 2px solid #015db2;
        }
        .teacher {
          display: inline-block;
          padding-bottom: 10px;
          margin-right: 30px;
          cursor: pointer;
          color: #676767;
        }
        .student {
          color: #676767;
          padding-bottom: 10px;
          cursor: pointer;
          display: inline-block;
        }
      }
      input {
        display: block;
        margin: 0 auto;
        width: 285px;
        height: 50px;
        font-size: 16px;
        border-radius: 10px;
        border: 1px solid #c5d7e5;
        padding-left: 50px;
        outline: none;
      }
      .input-username {
        width: 100%;
        margin-top: 30px;
        margin-bottom: 12px;
        position: relative;
        img {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 17px;
          left: 44px;
        }
      }
      .input-password {
        width: 100%;
        position: relative;
        img {
          width: 25px;
          height: 25px;
          position: absolute;
          top: 15px;
          left: 40px;
        }
      }
      button {
        width: 285px;
        height: 50px;
        color: #ffffff;
        font-size: 20px;
        cursor: pointer;
        background-color: #035bb2;
        border-radius: 10px;
        outline: none;
        border: none;
        display: block;
        margin: 15px auto 0;
      }
      .login-other {
        width: 285px;
        color: #025ab1;
        font-size: 14px;
        display: block;
        margin: 20px auto 0;
        line-height: 27px;
        .fl {
          display: flex;
          justify-content: center;
        }
        .wechaticon {
          cursor: pointer;
          color: #000;
          display: inline-block;
          width: 27px;
          height: 27px;
        }
        .forget {
          cursor: pointer;
        }
      }
    }
  }
  .school {
    width: 100%;
    height: 100%;
    h3 {
      margin-bottom: 15px;
    }
    .school-box {
      width: 100%;
      img {
        width: 71px;
        height: 71px;
        border-radius: 50%;
      }
      .div-img {
        margin-bottom: 35px;
        height: 107px;
        color: #ffffff;
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 1px solid #bfbfbf;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .div {
        margin-bottom: 35px;
        height: 107px;
        color: #ffffff;
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .one {
        background-color: #be302c;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .two {
        background-color: #11235d;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .three {
        background-color: #68a5c2;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .clearfix:after {
    clear: both;
    content: " ";
    display: block;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .profession {
    width: 100%;
    height: 100%;
    .div-row {
      width: 100%;
      height: 100%;
      .div-col {
        vertical-align: top;
        @media screen and (max-width: 768px) {
          width: 100%;
          padding: 0px;
        }
      }
      .div-col-left {
        width: calc(60% - 10px);
        padding-right: 10px;
        float: left;
        @media screen and (max-width: 992px) {
          width: 100%;
        }
      }
      .div-col-right {
        width: calc(40% - 10px);
        padding-left: 10px;
        float: right;
        @media screen and (max-width: 992px) {
          width: 100%;
          margin-top: 30px;
        }
      }
    }
    .pro-line {
      width: 20px;
      background-color: #ffffff;
      display: inline-block;
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
    margin-bottom: 40px;
    h3 {
      margin-bottom: 15px;
    }
    .profession-left {
      height: 100%;
      min-height: 345px;
      background-color: #f4f4f4;
      @media screen and (max-width: 992px) {
        margin-right: 0px;
      }
      p {
        background-color: #035bb2;
        height: 55px;
        text-align: center;
        line-height: 55px;
        color: #ffffff;
        font-size: 20px;
        margin: 0;
      }
      ul {
        width: 100%;
        height: 100%;
        padding-top: 35px;
        padding-left: 20px;
        padding-right: 20px;
        @media screen and (max-width: 768px) {
          padding-top: 25px;
        }
        li {
          // margin-left: 10px;
          margin-bottom: 20px;
          padding: 0 8px;
          display: inline-block;
          text-align: center;
          line-height: 36px;
          height: 36px;
          width: 20%;
          @media screen and (max-width: 768px) {
            width: 50%;
            font-size: 12px;
            padding: 0 5px;
            margin-bottom: 8px;
          }
          cursor: pointer;
          span {
            width: 100%;
            height: 36px;
            display: inline-block;
            background-color: #ffffff;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }
    .profession-right {
      height: 100%;
      min-height: 345px;
      background-color: #f4f4f4;
      p {
        background-color: #035bb2;
        height: 55px;
        text-align: center;
        line-height: 55px;
        color: #ffffff;
        font-size: 20px;
        margin: 0;
      }
      ul {
        width: 100%;
        height: 100%;
        padding-top: 35px;
        padding-left: 20px;
        padding-right: 20px;
        li {
          margin-bottom: 20px;
          padding: 0 8px;
          display: inline-block;
          text-align: center;
          line-height: 36px;
          height: 36px;
          width: 33.33%;
          @media screen and (max-width: 768px) {
            width: 50%;
            font-size: 12px;
            padding: 0 5px;
            margin-bottom: 8px;
          }
          cursor: pointer;
          span {
            width: 100%;
            height: 36px;
            display: inline-block;
            background-color: #ffffff;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }
  }
  .poster {
    width: 100%;
    height: 125px;
    margin-bottom: 48px;

    @media screen and (max-width: 768px) {
      height: 70px;
    }
    // background-image: url("./../assets/20.gif");
    // background-position: center center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    // background-color: #6e9bdc;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bulletin {
    height: 100%;
    .main {
      float: left;
      width: 100%;
      min-height: 250px;
      p {
        cursor: pointer;
      }
    }
  }
}
</style>
